import {
  PRODUCT_MODEL_DATA,
  PRODUCT_MODEL_KEY
} from 'models/daos/product/constants'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  compactArrayUtil,
  getObjectUtil
} from 'packages/src'

function getOptionsProductUtil (instance) {
  const data = getValueReduxUtil(instance, PRODUCT_MODEL_KEY.DATA)
  const option = getObjectUtil(data, 'option')
  // TODO add more options
  return compactArrayUtil([
    option,
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION1),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION2),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION3),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION4),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION5),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION6),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION7),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION8),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION9),
    getObjectUtil(data, PRODUCT_MODEL_DATA.OPTION10)
  ])
}

export {
  getOptionsProductUtil
}
